import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { BROADCAST_STATES, BroadcastStatus } from '../stores/types/broadcasting';
import { GreenroomState as GS } from '../stores/types/types';

// Provider-agnostic "what state is the broadcast in" value, usable by both the
// Bullman path (serverState) and the LiveKit/spielberg path (spielbergBroadcast).
// Kept dependency-light (no broadcasting/constants.ts, sockets, analytics, etc.)
// so it can be imported from anywhere without risking circular-require issues.
const useBroadcastStatus = (): BroadcastStatus => {
	const serverState = useSelector((s: GS) => s.BroadcastReducer.serverState);
	const spielbergBroadcast = useSelector((s: GS) => s.BroadcastReducer.spielbergBroadcast);
	const { use_spielberg: useSpielberg } = useSelector((s: GS) => s.SettingsReducer.featureFlags);

	return useMemo(() => {
		if (useSpielberg) {
			return spielbergBroadcast?.status ?? BroadcastStatus.ready;
		}

		switch (serverState) {
			case BROADCAST_STATES.READY: return BroadcastStatus.ready;
			case BROADCAST_STATES.BROADCAST_STOPPED: return BroadcastStatus.complete;
			case BROADCAST_STATES.BROADCAST_STARTING: return BroadcastStatus.starting;
			case BROADCAST_STATES.BROADCAST_STARTED: return BroadcastStatus.active;
			case BROADCAST_STATES.BROADCAST_FAILED: return BroadcastStatus.failed;
			default: return BroadcastStatus.ready;
		}
	}, [serverState, spielbergBroadcast, useSpielberg]);
};

export default useBroadcastStatus;
